/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_ContactInputs */

const es_footer_link_contact = /** @type {(inputs: Footer_Link_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo contactar`)
};

const gl_footer_link_contact = /** @type {(inputs: Footer_Link_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como contactar`)
};

const en_footer_link_contact = /** @type {(inputs: Footer_Link_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to contact us`)
};

/**
* | output |
* | --- |
* | "How to contact us" |
*
* @param {Footer_Link_ContactInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_link_contact = /** @type {((inputs?: Footer_Link_ContactInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_ContactInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_link_contact(inputs)
	if (locale === "en") return en_footer_link_contact(inputs)
	return es_footer_link_contact(inputs)
});